import { useTranslations } from "@packages/i18n";
import { SPEEDS, usePlayerSpeedIndex } from "@packages/media";

import { ModalTab, PlaybackSpeedIcon } from "../../../../../components";

export const SelectPlaybackSpeedTab = () => {
  const { currentIdx } = usePlayerSpeedIndex();
  const t = useTranslations();

  return (
    <ModalTab
      key={"speedSelectMenuTab"}
      value={"speedSelectMenu"}
      label={t("track_settings_playback_speed")}
      startIcon={<PlaybackSpeedIcon />}
    >
      {t("web_audio_player_speed", { "0": SPEEDS[currentIdx] })}
    </ModalTab>
  );
};
